import { useQuery } from "@tanstack/react-query";
import { listRecentActivitiesOptions } from "@/api";

/** Newest activity across my spaces (Home and Spaces share this query). */
export function useRecentActivity(limit = 8) {
  return useQuery({ ...listRecentActivitiesOptions({ query: { limit } }), select: (r) => r.data });
}
